import React from 'react';

import { useResponsive } from '../../../hooks/useResponsive';
import { TimeFrame } from './timeframe';
import { type PlainDate } from '../../../core/services/plain-date';

import styles from './header-left.module.scss';
interface ScreenProps {
  title: string;
  dueDate?: PlainDate | null;
  startDate?: PlainDate | null;
  onUpdate: (values: { dueDate?: PlainDate | null; startDate?: PlainDate | null }) => void;
}

export const HeaderLeft: React.FC<ScreenProps> = ({ title, dueDate, startDate, onUpdate }) => {
  const { isDesktop } = useResponsive();

  return (
    <div className={styles['left']}>
      <h1 className={styles['screen-title']}>{title}</h1>

      {isDesktop && (
        <div className={styles['step-dead-line']}>
          <TimeFrame dueDate={dueDate} startDate={startDate} onUpdate={onUpdate} />
        </div>
      )}
    </div>
  );
};
